module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-SUBOX_MINI.76bced95.jpg";